import moment from 'moment-timezone';
import { sum } from 'ramda';
import config from '../../../config';

export const makeDetails = (rows) => {
  if (!rows || !Array.isArray(rows) || rows.length === 0) {
    return {};
  }

  try {
    const result = rows.reduce((acc, row) => {
      if (!row.fromDate) {
        return acc;
      }

      const momentDate = moment(row.fromDate);
      if (!momentDate.isValid()) {
        return acc;
      }

      const formattedDate = momentDate.format(config.dateFormatISO);

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(row);
      return acc;
    }, {});

    return result;
  } catch (error) {
    return {};
  }
};

const safeNumber = (value) => Number(value) || 0;

export const calculatePayoutSummary = (byDate) => {
  if (!Array.isArray(byDate)) {
    return {
      transferDate: null,
      fromDate: null,
      toDate: null,
      shopAmount: 0,
      barberAmount: 0,
      tipsDeposited: 0,
      barberDeposited: 0,
    };
  }

  return byDate.reduce(
    (result, row) => {
      if (row.transferredToBarber) {
        result.barberAmount += sum([
          safeNumber(row.servicesRevenue),
          safeNumber(row.productsRevenue),
          safeNumber(row.servicesInstantPayoutFee),
          safeNumber(row.productsInstantPayoutFee),
        ]);

        result.barberDeposited += sum([safeNumber(row.servicesRevenue), safeNumber(row.productsRevenue)]);
      }

      if (row.barberId || row.unassigned) {
        result.shopAmount += sum([
          safeNumber(row.productsDueToShop),
          safeNumber(row.servicesDueToShop),
          safeNumber(row.totalProductsTaxAmount),
          safeNumber(row.totalServicesTaxAmount),
        ]);
      }

      if (!result.transferDate) {
        result.transferDate = row.createdAt;
        result.fromDate = row.fromDate;
        result.toDate = row.toDate;
      }

      if (row.tips && row.tips.totalDeposited) {
        result.tipsDeposited += safeNumber(row.tips.totalDeposited);
      }

      return result;
    },
    {
      transferDate: null,
      fromDate: null,
      toDate: null,
      shopAmount: 0,
      barberAmount: 0,
      tipsDeposited: 0,
      barberDeposited: 0,
    }
  );
};
